module.exports = __webpack_public_path__ + "static/media/Resume.570d6a1b.pdf";